var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2046 52.9272C33.7937 53.0845 30.3287 53.1667 26.513 53.1667C22.6972 53.1667 19.2322 53.0845 15.8212 52.9272C11.7675 52.7401 8.43634 49.5779 7.89486 45.5414C7.54147 42.9072 7.25 40.2075 7.25 37.4583C7.25 34.7091 7.54145 32.0095 7.89486 29.3753C8.43634 25.3388 11.7675 22.1765 15.8212 21.9895C19.2322 21.8321 22.6972 21.75 26.513 21.75C30.3287 21.75 33.7937 21.8321 37.2046 21.9895C39.765 22.1076 42.037 23.4126 43.5 25.375",
    stroke: "#2C4A3A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.082 36.1962C41.082 33.5562 43.2459 31.416 45.9154 31.416C48.5848 31.416 50.7487 33.5562 50.7487 36.1962C50.7487 37.1479 50.4676 38.0345 49.9829 38.7794C48.5384 40.9995 45.9154 43.1165 45.9154 45.7568V46.9518M45.9154 53.166H45.9444",
    stroke: "#2C4A3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.707 21.7506V15.709C15.707 9.70289 20.5759 4.83398 26.582 4.83398C32.5882 4.83398 37.457 9.70289 37.457 15.709V21.7506",
    stroke: "#2C4A3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37.4336V37.4578",
    stroke: "#2C4A3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.332 37.4336V37.4578",
    stroke: "#2C4A3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.802333b5a83d94bf1ad249955e1611ad.svg";
export { ForwardRef as ReactComponent };